import { useTranslation } from "react-i18next";
import bg from "../../../assets/banner2.jpg";
import "./style.css";

const About = () => {
	const { t } = useTranslation();

	return (
		<div className="about-home">
			<div className="container">
				<div className="row">
					<div className="col-md-6 col-12">
						<p className="tag">{t("about-us")}</p>
						<p className="title">Masters of Consistency and Quality.</p>
						<p className="description">
							There are many variations of passages of Lorem Ipsum available,
							but the majority have suffered alteration in some form, by
							injected humour, or randomised words which don't look even
						</p>
					</div>
					<div className="col-md-6 col-12">
						<img src={bg} alt="bg" className="w-100" />
					</div>
				</div>
			</div>
		</div>
	);
};
export default About;
